import React from 'react'
import {NaverMap, Marker} from 'react-naver-maps';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {GET_HEIGHT_FOR_NAVER_MAP, SVG_MARKER_ICON} from "../../../modules/variable/common_variable";


class SimpleSearchNaverMap extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            mapBounds: null,
            currentSearchList: []
        };
    }

    naverMapSimpleSearch = window.naver.maps;

    componentDidMount(){

    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.simpleSearchList){
            const SSL = nextProps.simpleSearchList;
            if(SSL.bounds){
                this.setState({
                    mapBounds: new this.naverMapSimpleSearch.LatLngBounds(
                        new this.naverMapSimpleSearch.LatLng(SSL.bounds.minY, SSL.bounds.minX),
                        new this.naverMapSimpleSearch.LatLng(SSL.bounds.maxY, SSL.bounds.maxX)
                    )
                });
            }
            if(SSL.currentSearchList){
                this.setState({
                    currentSearchList: SSL.currentSearchList
                });
            }
        }

        /*if(bounds.minX !== 0 && bounds.minY !== 0 && bounds.maxX !== 0 && bounds.maxY !== 0 && (bounds.minX !== bounds.maxX) && (bounds.minY !== bounds.maxY)){

        }*/
    }

    render() {
        return (
            <div style={this.state.currentSearchList && this.state.currentSearchList.length !== 0 ? {} : {display: 'none'}}>
                <NaverMap
                    id={'naver-map-simple-search'}
                    className={'naver--map'}
                    naverRef={ref => { this.naverMapSimpleSearchRef = ref }}
                    style={{width: window.innerWidth - 16, height: GET_HEIGHT_FOR_NAVER_MAP(window.screenSizeProperty === 'md' ? 450 : 250)}}
                    defaultCenter={new this.naverMapSimpleSearch.LatLng(37.5666805, 126.9784147)}
                    defaultZoom = {8}
                    logoControl={false}
                    mapDataControl={false}
                    /*draggable={false}
                    pinchZoom={false}
                    scrollWheel={false}
                    keyboardShortcuts={false}
                    disableDoubleTapZoom={true}
                    disableDoubleClickZoom={true}
                    disableTwoFingerTapZoom={true}*/
                    bounds={this.state.mapBounds}
                >
                    {
                        this.state.currentSearchList.map((e, i) => {
                            return (
                                <Marker key={['searched', 'marker', e.DOC_ID, i].join('_')}
                                        position={new this.naverMapSimpleSearch.LatLng(e.schedule[e.scheduleOrder[0]].y, e.schedule[e.scheduleOrder[0]].x)}
                                        icon= {
                                            {content: ['<div class="naver-map-pin-schedule"',
                                                    'id="',
                                                    ['searched', 'marker', e.DOC_ID, i].join('_'),
                                                    '">',
                                                    '<span data-balloon-visible data-balloon="', e.title, '" data-balloon-pos="up" data-balloon-type="marker">',
                                                    SVG_MARKER_ICON['marked'],
                                                    '</span>',
                                                    '</div>'].join('')}
                                        }
                                        onClick={() => {
                                            this.props.showTargetSchedule(e)
                                        }}
                                />
                            )
                        })
                    }
                </NaverMap>
            </div>
        )
    }
}

const mapStateToProps = ({user}) => ({
    userInfo: user.userInfo,
});

export default withRouter(connect(
    mapStateToProps
)(SimpleSearchNaverMap))

